import { tokens as sheetTokens } from '@pkg/components/Sheet/tokens';

export const tokens = {
    title: {
        mediumSize: 20,
    },
    section: {
        gap: 16,
        spacing: sheetTokens.spacing.loose,
        header: {
            gap: 4,
        },
    },
};
